// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"c41a4feb","505":"79ef8bf3","960":"2e648f31"}[chunkId] + ".chunk.js";
};